// `extension.preferences.api.ng1.ts` — the four "automatically present Woo screen" toggles
// behind the header menu's Settings item.
//
// ⚠️ THE PATH HAS NO ENTITY SEGMENT. It is `/chrome-extension-api/preferences`, not
// `…/extension-preferences` or `…/user-preferences`; both read plausibly and both 404.
import { request } from './request.ts'

/** `IExtensionPreferences`. Every toggle is TRI-STATE — see `update`. */
export interface ExtensionPreferences {
  version: number
  /**
   * ⚠️ `undefined`/`null` IS A THIRD VALUE, NOT "OFF". Upstream's form draws a `not-set`
   * switch — a yellow "Default" pill with no knob — for a preference the user has never
   * touched, and offers a × that puts it back to `null`. Reading absent as `false` turns
   * "follow the tenant default" into "the user turned this off".
   */
  autoOpenCandidatesOnATS?: boolean | null
  autoOpenCandidatesOnLinkedIn?: boolean | null
  autoOpenSearchesOnLinkedIn?: boolean | null
  autoOpenSearchesOnIndeed?: boolean | null
}

export async function getExtensionPreferences(): Promise<ExtensionPreferences> {
  return request('GET', '/chrome-extension-api/preferences')
}

/**
 * ⚠️ A WRITE, AND THE ONLY ONE IN THE HEADER MENU. It is the user's own preference rather
 * than anything outward-facing — nothing is mailed and no customer record changes — and
 * upstream fires it on every toggle, with the server's answer replacing the cached copy.
 */
export async function updateExtensionPreferences(
  preferences: ExtensionPreferences,
): Promise<ExtensionPreferences> {
  return request('POST', '/chrome-extension-api/preferences', preferences)
}
